import { render } from "./DeliveryAppVersionPage.vue?vue&type=template&id=74e07165&scoped=true"
import script from "./DeliveryAppVersionPage.vue?vue&type=script&lang=js"
export * from "./DeliveryAppVersionPage.vue?vue&type=script&lang=js"

import "./DeliveryAppVersionPage.vue?vue&type=style&index=0&id=74e07165&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e07165"]])

export default __exports__